export function fadeout(node: HTMLElement, { duration }: { duration: number } = { duration: 200}) {
  return {
    duration,
    css: (t: number) => `position: absolute; opacity: ${t};`
  };
}

export function fadein(node: HTMLElement, { duration }: { duration: number } = { duration: 200}) {
  return {
    duration,
    css: (t: number) => `opacity: ${t};`
  };
}